import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useShippingStore = create(
  persist(
    (set, get) => ({
      shippingAddress: {
        name: "",
        email: "",
        phone: "",
        district: "",
        thana: "",
      },
      paymentShipping: {
        shipping_carrier: "",
        shipping_type: "",
        shipping_cost: 0,
      },
      paymentMethod: "cash on delivery",
      order: null,
      orderFrom: "",
      setShipping: (newData) =>
        set((state) => ({
          shippingAddress: { ...state.shippingAddress, ...newData },
        })),
      setOrder: (newData) => {
        set({ order: newData });
      },
      setPaymentShipping: (newData) =>
        set((state) => ({
          paymentShipping: {
            shipping_type: newData?.shipping_type,
            shipping_cost: newData?.shipping_cost,
          },
        })),
      setPaymentMethod: (newData) => set({ paymentMethod: newData }),
      setOrderFrom: (data) => set({ orderFrom: data }),
    }),
    {
      name: "shippingStore",
    }
  )
);
